
      import WechatPay from './wechat-pay.vue'
      import type { App, Plugin } from 'vue'

      export const WechatPayPlugin: Plugin = {
        install(app: App) {
          app.component('WechatPay', WechatPay)
        },
      }
      export { WechatPay }
      